module.exports = __webpack_public_path__ + "img/img17.8dd55462.svg";